import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { DataService } from 'services/data.service';
import { User } from 'domain-models/User';
import { environment } from '../../environments/environment';
import { Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { AppError } from 'app/common/app-error';
import { NotFoundError } from 'app/common/not-found-error';
import { BadInput } from 'app/common/bad-input';

@Injectable()
export class WeightStationService {
	url;
	constructor(private http: Http) {
		// super(environment.host + "WeightStations", http);
		this.url = environment.host + 'WeightStations';
	}
	postMessage(signIds: string[], message: string): Observable<any> {
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		let token = localStorage.getItem('readToken');
		headers.append('x-access-token', token);
		let tokenw = localStorage.getItem('token');
		headers.append('x-access-tokenw', tokenw);

		return this.http
			.post(this.url + '/postMessage', JSON.stringify({ signIds, message }), {
				headers: headers
			})
			.map((response) => {
				return response;
			})
			.catch(this.handleError);
	}
	currentMessage(signIds: string[]): Observable<any> {
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		let token = localStorage.getItem('readToken');
		headers.append('x-access-token', token);

		return this.http
			.post(this.url + '/currentMessage', JSON.stringify({ signIds }), {
				headers: headers
			})
			.map((response) => {
				return response;
			})
			.catch(this.handleError);
	}

	private handleError(error: Response) {
		if (error.status === 404) {
			console.log('error 404');
			return Observable.throw(new NotFoundError());
		}
		if (error.status === 400) return Observable.throw(new BadInput(error.json()));
		if (error.status === 401) return Observable.throw(new BadInput(error.json()));

		return Observable.throw(new AppError(error));
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/services/weight-station/weight-station.service.ts